import { useQuery } from '@tanstack/react-query';
import { apiClient } from './client';
import type { StationsOverviewResponse } from '@/types/api';

export function useStationsOverview(year: number) {
  return useQuery({
    queryKey: ['stations-overview', year],
    queryFn: async () => {
      const res = await apiClient.get<StationsOverviewResponse>('/stations-overview/data', {
        params: { year },
      });
      return res.data;
    },
    staleTime: 300 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
  });
}
